import { onAccessTokenFetched } from "@root-gipro/modules/userProjects/utils/helpers"
import { refreshToken } from "@root-gipro/store/api"


export const fetchWith401Retry = async (input: RequestInfo, init: RequestInit = {}): Promise<Response> => {
	const makeRequest = async () => {
		const token = localStorage.getItem('access_token')
		return fetch(input, {
			...init,
			headers: {
				...(init.headers || {}),
				Authorization: `Bearer ${token}`,
			},
		})
	}

	let response = await makeRequest()

	if (response.status === 401) {
		try {
			const refresh_token = localStorage.getItem('refresh_token')
			if (!refresh_token) throw new Error('No refresh token')

			const { access_token, refresh_token: new_refresh_token } = await refreshToken(refresh_token)

			localStorage.setItem('access_token', access_token)
			localStorage.setItem('refresh_token', new_refresh_token)
			onAccessTokenFetched?.(access_token)

			response = await makeRequest()
		} catch (e) {
			console.error('Refresh token failed', e)
			throw e
		}
	}

	return response
}
